// --zrPrimary
export const ZR_PRIMARY = '#85c1f6'; /* Brand color: not for use with white */
// --zrPrimaryDark
export const ZR_PRIMARY_DARK = '#1879c3'; /* useable with white */

export const ZR_PRIMARY_VERY_DARK = '#0a416c';
